import type { InitiatePaymentResponse } from '@/types';
import { launchCashfreeCheckout } from './cashfreeCheckout';

export async function launchPaymentCheckout(payment: InitiatePaymentResponse): Promise<void> {
  if (payment.checkoutUrl) {
    window.location.href = payment.checkoutUrl;
    return;
  }

  if (payment.paymentSessionId) {
    await launchCashfreeCheckout(payment.paymentSessionId);
    return;
  }

  throw new Error('Payment could not be started. Please try again.');
}
